import { ActivityType, LegalEntityType, ProfileType } from '@lw-modules/onboarding-platform';

export const accountOptionsData = {
  individualOptions: {
    CROWDFUNDING_MONEYPOT: {
      INDIVIDUAL: {
        profiles: [ProfileType.Donor, ProfileType.ProjectHolder]
      }
    }
  },
  cseOptions: {
    [ActivityType.Cse]: {
      INDIVIDUAL: {
        profiles: [ProfileType.Employee]
      },
      'LEGAL-ENTITY': {
        profiles: {
          [ProfileType.Cse]: {
            'entity-types': [LegalEntityType.Association]
          }
        }
      }
    }
  },
  legalEntityOptions: {
    CROWDFUNDING_DONATION: {
      'LEGAL-ENTITY': {
        profiles: {
          BUYER: {
            'entity-types': [LegalEntityType.Company, LegalEntityType.SoleTrader]
          },
          CREDITOR: {
            'entity-types': [LegalEntityType.Company, LegalEntityType.Association]
          }
        }
      }
    }
  }
};

export const accountOptionsResponses = {
  individual: {
    status: 200,
    contentType: 'application/json',
    body: JSON.stringify(accountOptionsData.individualOptions)
  },
  legalEntity: {
    status: 200,
    contentType: 'application/json',
    body: JSON.stringify(accountOptionsData.legalEntityOptions)
  },
  cse: {
    status: 200,
    contentType: 'application/json',
    body: JSON.stringify(accountOptionsData.cseOptions)
  },
  grouped: {
    status: 200,
    contentType: 'application/json',
    body: JSON.stringify({
      ...accountOptionsData.individualOptions,
      ...accountOptionsData.legalEntityOptions
    })
  }
};
